import { useRef } from "react";
import { useMount } from "constants/constants";

/** fire a callback after long-pressing */
export function useLongPressTimer({
  callback,
  delay,
}: {
  // eslint-disable-next-line @typescript-eslint/ban-types
  callback: Function;
  delay: number;
}) {
  const longPressTimer = useRef(null as any);

  useMount(() => {
    return () => {
      window.clearTimeout(longPressTimer.current);
    };
  });

  const handleButtonPress = event => {
    event.preventDefault();
    event.stopPropagation();
    longPressTimer.current = setTimeout(callback, delay);
  };

  const handleButtonRelease = () => {
    window.clearTimeout(longPressTimer.current);
  };

  const onContextMenu = event => event.preventDefault();
  const onTouchStart = handleButtonPress;
  const onMouseDown = handleButtonPress;
  const onTouchEnd = handleButtonRelease;
  const onMouseUp = handleButtonRelease;

  return {
    handleButtonPress,
    handleButtonRelease,
    onContextMenu,
    onTouchStart,
    onMouseDown,
    onTouchEnd,
    onMouseUp,
  };
}
